import { render, staticRenderFns } from "./SettingPengadaan.vue?vue&type=template&id=992375de&scoped=true"
import script from "./SettingPengadaan.vue?vue&type=script&lang=js"
export * from "./SettingPengadaan.vue?vue&type=script&lang=js"
import style0 from "./SettingPengadaan.vue?vue&type=style&index=0&id=992375de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992375de",
  null
  
)

export default component.exports